import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logout, getUsuarioLogado, apiCallAuth } from '../utils/auth';
import BASE_URL from '../utils/api';
import './Configuracoes.css';
export default function Configuracoes() {
  const navigate = useNavigate();
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [pendingRoute, setPendingRoute] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Pegar usuário logado e verificar permissões
  const usuarioLogado = getUsuarioLogado();
  const tipoUsuarioLoginId = usuarioLogado?.tipoUsuarioLoginId || usuarioLogado?.TipoUsuarioLoginId;
  const podeGerenciarFuncionarios = tipoUsuarioLoginId === 5 || tipoUsuarioLoginId === 6;
  // Apenas CEO (tipoUsuarioLoginId === 5) pode cadastrar contas bancárias
  const podeCadastrarContaBancaria = tipoUsuarioLoginId === 5;

  const handleLogout = () => {
    logout();
    navigate('/sidebar/Home');
  };

  // Verificar senha antes de acessar áreas protegidas
  const handleProtectedAccess = (route) => {
    setPendingRoute(route);
    setShowPasswordModal(true);
    setPassword('');
    setError('');
  };

  const handleConfirmPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const usuarioLogado = getUsuarioLogado();
      if (!usuarioLogado || !usuarioLogado.login) {
        setError('Usuário não encontrado. Faça login novamente.');
        setLoading(false);
        return;
      }

      // Verificar senha usando o endpoint de login existente
      const response = await fetch(`${BASE_URL}/Auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          login: usuarioLogado.login,
          senha: password
        })
      });

      if (response.ok) {
        // Senha correta - navegar para rota
        setShowPasswordModal(false);
        setPassword('');
        navigate(pendingRoute);
      } else {
        setError('Senha incorreta. Tente novamente.');
      }
    } catch (err) {
      console.error('Erro ao validar senha:', err);
      setError('Erro ao verificar senha. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowPasswordModal(false);
    setPassword('');
    setError('');
    setPendingRoute(null);
  };

  return (
    <div className="configuracoes-container">
      <div className="configuracoes-card">
        <div className="configuracoes-header">
          <h2>Configurações</h2>
          <p>Gerencie sua conta e preferências</p>
        </div>

        <div className="configuracoes-menu">
          {/* Minha Conta */}
          <Link to="/sidebar/MinhaConta" className="config-item">
            <div className="config-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#555" strokeWidth="1.5" fill="none"/>
                <circle cx="12" cy="9" r="3" fill="#555"/>
                <path d="M6 18.5c0-3 2.5-4.5 6-4.5s6 1.5 6 4.5" stroke="#555" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="config-content">
              <span className="config-title">Minha Conta</span>
              <span className="config-description">Visualize e edite suas informações</span>
            </div>
            <div className="config-arrow">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </Link>

          {/* Alterar Senha */}
          <Link to="/sidebar/AlterarSenha" className="config-item">
            <div className="config-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="10" width="16" height="11" rx="2" stroke="#555" strokeWidth="1.5" fill="none"/>
                <path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="#555" strokeWidth="1.5" strokeLinecap="round"/>
                <circle cx="10" cy="15.5" r="1.2" fill="#555"/>
                <circle cx="12" cy="15.5" r="1.2" fill="#555"/>
                <circle cx="14" cy="15.5" r="1.2" fill="#555"/>
              </svg>
            </div>
            <div className="config-content">
              <span className="config-title">Alterar Senha</span>
              <span className="config-description">Atualize sua senha de acesso</span>
            </div>
            <div className="config-arrow">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </Link>

          {/* Cadastrar Funcionários - Apenas para tipoUsuarioLoginId 5 ou 6 */}
          {podeGerenciarFuncionarios && (
            <button onClick={() => handleProtectedAccess('/sidebar/CadastrarUsuario')} className="config-item">
              <div className="config-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#555" strokeWidth="1.5" fill="none"/>
                  <path d="M12 8v8M8 12h8" stroke="#555" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <div className="config-content">
                <span className="config-title">Cadastrar Funcionários</span>
                <span className="config-description">Adicione novos colaboradores</span>
              </div>
              <div className="config-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18l6-6-6-6" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </button>
          )}

          {/* Gerenciar Funcionários - Apenas para tipoUsuarioLoginId 5 ou 6 */}
          {podeGerenciarFuncionarios && (
            <button onClick={() => handleProtectedAccess('/sidebar/GerenciarFuncionarios')} className="config-item">
              <div className="config-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 3a2.83 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="config-content">
                <span className="config-title">Gerenciar Funcionários</span>
                <span className="config-description">Edite e gerencie colaboradores</span>
              </div>
              <div className="config-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18l6-6-6-6" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </button>
          )}

          {/* Cadastrar Conta Bancária - somente CEO */}
          {podeCadastrarContaBancaria && (
            <Link to="/sidebar/CadastrarConta" className="config-item">
              <div className="config-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="8" width="20" height="12" rx="2" stroke="#555" strokeWidth="1.5" fill="none"/>
                  <path d="M2 12h20" stroke="#555" strokeWidth="1.5"/>
                  <rect x="5" y="14" width="4" height="2" rx="0.5" fill="#555"/>
                  <path d="M2 8L12 4L22 8" stroke="#555" strokeWidth="1.5" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="config-content">
                <span className="config-title">Cadastrar Conta Bancária</span>
                <span className="config-description">Configure dados bancários</span>
              </div>
              <div className="config-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18l6-6-6-6" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </Link>
          )}

          {/* Gerenciar Assinatura */}
          <Link to="/sidebar/Planos" className="config-item">
            <div className="config-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Envelope/Carta no fundo */}
                <rect x="2" y="6" width="20" height="14" rx="2" stroke="#555" strokeWidth="1.5" fill="none"/>
                <path d="M2 8l10 6 10-6" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                {/* Lápis assinando */}
                <path d="M15 2l4 4-8 8H7v-4l8-8z" fill="#fff" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M13 4l4 4" stroke="#555" strokeWidth="1.5"/>
              </svg>
            </div>
            <div className="config-content">
              <span className="config-title">Gerenciar Assinatura</span>
              <span className="config-description">Veja e gerencie seu plano</span>
            </div>
            <div className="config-arrow">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </Link>

          {/* Forum Empresas */}
          <Link to="/sidebar/ForumEmpresas" className="config-item">
            <div className="config-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="#555" strokeWidth="1.5" fill="none"/>
                <line x1="7" y1="8" x2="17" y2="8" stroke="#555" strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="7" y1="12" x2="17" y2="12" stroke="#555" strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="7" y1="16" x2="13" y2="16" stroke="#555" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="config-content">
              <span className="config-title">Forum Empresas</span>
              <span className="config-description">Comunicados e postagens globais</span>
            </div>
            <div className="config-arrow">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </Link>

          {/* Sair */}
          <button onClick={handleLogout} className="config-item config-item-logout">
            <div className="config-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="16,17 21,12 16,7" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="21" y1="12" x2="9" y2="12" stroke="#555" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="config-content">
              <span className="config-title">Sair</span>
              <span className="config-description">Encerrar sessão</span>
            </div>
            <div className="config-arrow">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </button>
        </div>
      </div>

      {/* Modal de Verificação de Senha */}
      {showPasswordModal && (
        <div className="password-modal-overlay" onClick={handleCloseModal}>
          <div className="password-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="password-modal-close" onClick={handleCloseModal}>×</button>
            
            <div className="password-modal-header">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="10" width="16" height="11" rx="2" stroke="rgb(235, 133, 0)" strokeWidth="1.5" fill="none"/>
                <path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="rgb(235, 133, 0)" strokeWidth="1.5" strokeLinecap="round"/>
                <circle cx="12" cy="15" r="1.5" fill="rgb(235, 133, 0)"/>
              </svg>
              <h3>Verificação de Segurança</h3>
              <p>Digite sua senha para continuar</p>
            </div>

            {error && <div className="password-modal-error">{error}</div>}

            <form onSubmit={handleConfirmPassword} className="password-modal-form">
              <div className="password-modal-input-group">
                <label htmlFor="verify-password">Senha</label>
                <div className="password-modal-input-wrapper">
                  <input
                    id="verify-password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Digite sua senha"
                    autoFocus
                    required
                    disabled={loading}
                  />
                  <button 
                    type="button" 
                    onClick={() => setShowPassword(s => !s)} 
                    className="password-modal-toggle"
                    aria-label="Mostrar senha"
                  >
                    {showPassword ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                        <path d="M3 3l18 18" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M17.94 17.94A10.95 10.95 0 0 1 12 20c-5 0-9.27-3-11-8 1.1-2.9 3.2-5.2 5.7-6.6" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9.88 9.88a3 3 0 0 0 4.24 4.24" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <circle cx="12" cy="12" r="3" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <div className="password-modal-actions">
                <button type="button" className="password-modal-cancel" onClick={handleCloseModal} disabled={loading}>
                  Cancelar
                </button>
                <button type="submit" className="password-modal-confirm" disabled={loading || !password}>
                  {loading ? 'Verificando...' : 'Confirmar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
